import { InjectionToken } from '@angular/core';

export const FORCE_VIEW_CHANNEL = new InjectionToken('FORCE_VIEW_CHANNEL');
